import { RevealWords, FadeUp } from "./Reveal";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
	return (
		<footer
			data-testid={FOOTER.root}
			className="relative border-t border-[var(--border-line)] bg-[var(--obsidian)] text-[var(--bone)] py-20 md:py-28"
		>
			<div className="max-container">
				<div className="grid grid-cols-12 gap-6 mb-16">
					<div className="col-span-12 md:col-span-10">
						<h3
							data-testid={FOOTER.closingNote}
							className="ctrl-h1 text-3xl md:text-5xl leading-[1.15] text-[var(--bone)] max-w-[28ch]"
						>
							<span className="block">
								<RevealWords
									trigger="inView"
									text="The next decade of business will be"
								/>
							</span>
							<span className="block">
								<RevealWords
									trigger="inView"
									delay={0.15}
									text="written by companies that learn to"
								/>
							</span>
							<span className="block">
								<RevealWords
									trigger="inView"
									delay={0.3}
									text="think with machines"
									className="neon-accent"
								/>
							</span>
							<span className="block">
								<RevealWords
									trigger="inView"
									delay={0.45}
									text="without losing the thread of judgment."
								/>
							</span>
						</h3>
					</div>
				</div>

				<div className="tick-line mb-10" />

				<div className="grid grid-cols-12 gap-6 items-end">
					<div className="col-span-12 md:col-span-4">
						<div className="flex items-center gap-3 mb-4">
							<span className="font-display text-xl tracking-[-0.02em] font-semibold whitespace-nowrap">Natant <span className="wordmark-ai">AI</span> Labs<span className="text-[var(--accent-green)]">.</span></span>
						</div>
						<FadeUp>
							<div className="text-[var(--bone-dim)] leading-relaxed">
								The Operating System for Business. <br />
								Ground-up. AI-native. Autonomous by default.
							</div>
						</FadeUp>
					</div>

					<div className="col-span-6 md:col-span-3">
						<div className="eyebrow mb-4">Contact</div>
						<a
							href="mailto:cohort1@natant.ai"
							className="block font-display text-lg text-[var(--bone)] hover:text-[var(--terracotta)] transition-colors"
						>
							cohort1@natant.ai
						</a>
						<a
							href="mailto:hello@natant.ai"
							className="block font-display text-lg text-[var(--bone-dim)] hover:text-[var(--terracotta)] transition-colors mt-1"
						>
							hello@natant.ai
						</a>
					</div>

					<div className="col-span-6 md:col-span-2">
						<div className="eyebrow mb-4">Reading</div>
						<a
							href="/whitepaper"
							className="block font-display text-lg hover:text-[var(--terracotta)] transition-colors"
						>
							Whitepaper 01
						</a>
					</div>

					<div className="col-span-12 md:col-span-3 md:text-right">
						<div className="eyebrow mb-4">Location · Year</div>
						<div className="font-display text-lg">Dubai — DXB</div>
						<div className="text-[var(--bone-dim)]">2026</div>
					</div>
				</div>

				<div className="mt-20 flex flex-wrap items-center justify-between gap-4 eyebrow">
					<div>© 2026 Natant AI Labs, Inc. · Built for the enterprise · Launched from the Middle East</div>
					<div className="flex items-center gap-6">
						<span>Composable</span>
						<span className="text-[var(--terracotta)]">/</span>
						<span>Agentic</span>
						<span className="text-[var(--terracotta)]">/</span>
						<span>AI-native</span>
					</div>
				</div>
			</div>
		</footer>
	);
}
